// package type badge and voice/SMS description, shared by the package list and the pre-invoice

export const PackageTypeTag = ({ pkg }) => {
	if (pkg?.packageType === 1) return <span className="internet">بسته اینترنت</span>;
	if (pkg?.packageType === 2) return <span className="combo">بسته ترکیبی</span>;
	if (pkg?.specialPackageType === 2) return <span className="roaming">رومینگ عراق</span>;
	if (pkg?.specialPackageType === 1) return <span className="roaming">رومینگ ترکیه</span>;
	return null;
};

// type 12 is the Turkey roaming package; plus = also prefix the voice part with "+" (pre-invoice, after the package name)
export const PackageFeatures = ({ pkg, plus = false }) => (
	<>
		{pkg?.voiceCallInDoorDescription !== "0 دقیقه" && (
			<>
				{plus && "+"}
				{pkg?.voiceCallInDoorDescription}
				{pkg?.packageType === 12 ? <> مکالمه با خطوط ترکیه</> : <> مکالمه آپتلی و غیرآپتلی</>}{" "}
			</>
		)}
		{pkg?.smsDescription !== "0 عدد" && pkg?.smsDescription !== "0" && (
			<>
				+{pkg?.smsDescription}
				{pkg?.packageType === 12 ? <> پیامک به ایران</> : <> پیامک</>}{" "}
			</>
		)}
	</>
);
